import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

import { DEFAULT_MARKET, MARKETS } from '../config'

/**
 * Get the default currency for a market.
 *
 * @param marketCode - market code
 */
export function getMarketCurrency(marketCode: MarketCountryCode) {
  const market = MARKETS[marketCode]

  return market?.defaultCurrency ?? DEFAULT_MARKET.defaultCurrency
}
